'use client'

import { useTranslate } from '@repo/shared'
import { useRouter, usePathname } from '@repo/shared/i18n/navigation'
import { Icon, Row, Typography } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'
import { useSearchParams } from 'next/navigation'
import React, { useState, useEffect } from 'react'
import { twMerge } from 'tailwind-merge'

export const ProjectsDetailTradeAction = () => {
  const { t } = useTranslate()
  const { push } = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop
      setShowButton(scrollY > 100)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Check initial scroll position

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleClick = () => {
    const current = new URLSearchParams(Array.from(searchParams.entries()))
    current.set('tab', 'trade')
    const query = current.toString()
    push(`${pathname}?${query}`)
  }

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 p-md z-50 flex justify-center transition-all duration-300',
        showButton
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-full pointer-events-none',
      )}
    >
      <Row
        className={cn(
          'w-[160px] gap-xs bg-base-radial-gradient transition-all duration-300 h-12 cursor-pointer rounded-full items-center justify-center px-xs flex',
        )}
        onClick={handleClick}
      >
        <Icon
          name='ArrowDownLeftArrowUpRight'
          size='md'
          color='fill-neutral-surface'
        />
        <Typography
          variant='span'
          size='lg'
          weight='bold'
          color='text-neutral-surface'
          className={twMerge('whitespace-nowrap')}
        >
          {t('menu_trade_regular_title')}
        </Typography>
      </Row>
    </div>
  )
}
